// TODO: consider splitting this file up as we can lazy load later?
const formatMeasurementMM = (measurementInCm) => {
    return Math.round(measurementInCm * 10);
};
const formatMeasurementCM = (measurementInCm) => measurementInCm;

export { formatMeasurementMM, formatMeasurementCM };
